<template>
  <div>
    <v-textarea
      solo
      name="input-7-4"
      style="border-radius: 10px"
      outlined
      @input="setModelData"
      :value="model"
    />
  </div>
</template>

<script>
export default {
  props: {
    model: ""
  },
  name: "InputTextArea",
  methods: {
    setModelData(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style scoped></style>
